var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgResultHome = function SvgResultHome(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFE9A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.917 9.167 10 3.333l7.083 5.834"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M5 7.708v8.125c0 .459.375.834.833.834h2.5v-3.75h3.334v3.75h2.5a.836.836 0 0 0 .833-.834V7.708"
  }))));
};
export default SvgResultHome;